<template>
  <div class="container wishes_answer">
      <div class="wish_answer_wrap">
        <textarea :placeholder="placeholder" v-model="textInput" maxlength="200"></textarea>
        <div class="text_limit"><span>{{inputTextCount}}</span>/200</div>
        <a href="javascript:;" class="btn btn-default" @click="addReplySubmit">提交</a>
      </div>  
      <!-- 提示弹框 -->
        <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	loading:true,
      textInput:'',
      tipDialog:false,
      tipText:'',
      btnClickCount:0,
    }
  },
  components:{
    XDialog,
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
      addWishReply:'getAddWishReply'
    }),
    replyId(){
      return this.$route.query.replyId;
    },
    name(){
      return this.$route.query.name;
    },
    placeholder(){
      let name=this.name?this.name:'';
      let text="回复 "+name;
      return text;
    },  
    inputTextCount(){
      if(this.textInput){
        return this.textInput.length;
      }else{
        return 0;
      }
    }
  },
  watch:{
    addWishReply(cval){
      if(cval){
        this.btnClickCount=0;
        this.$router.push({
          name:'birthdayPersonal'
        })
      }
    }
  },
  created(){
    
  },
  methods:{
    showMsg(txt){
      this.tipText=txt;
      this.tipDialog=true;
    },
    addReplySubmit(){
      if(!this.textInput){
        this.showMsg('您还没有填写任何回复！')
        return false;
      }
      if(this.btnClickCount>0){
        this.showMsg('您不能重复回复哦！')
        return false;
      }
      this.$store.dispatch('doBirthdayWishReplyAdd',{wishId:this.replyId,content:this.textInput})
      this.btnClickCount++;
    }
  },
  mounted(){}
}
</script>